import * as yup from "yup"

export const validationSchema = yup.object().shape({
    payment_term_vendor_code: yup.string().label("Payment term code").required().max(2, 'Maximum code is 2 characters'),
    payment_term_vendor_name: yup.number().label("Payment term name").required().max(100, "Must be 100 characters or less"),
    description: yup.string().label("Description").optional()
  })